/**
 * Route for `disallowed-traffic`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DisallowedTrafficPage } from "../features/disallowed-traffic/DisallowedTrafficPage";

export const disallowedTrafficRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/disallowed-traffic",
	component: DisallowedTrafficPage,
});

export default disallowedTrafficRoute;
